<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <!-- <erp-project @node-click="nodeClick"></erp-project> -->
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
<!--    <el-select size="mini" v-model="pindex_id" filterable placeholder="请选择" class="kuan">-->
<!--      <el-option-->
<!--        v-for="item in options1"-->
<!--        :key="item.id"-->
<!--        :label="item.name"-->
<!--        :value="item.id">-->
<!--      </el-option>-->
<!--    </el-select>-->
<!--    <el-button size="mini" type="primary text2" @click="change(1)">搜索</el-button>-->
    <!-- <div style="margin-top: 10px;color: red;">选择项目搜索</div> -->
    <v-divider></v-divider>
    <div style="margin-top: 10px;display: flex;">
      <div style="height: 680px;overflow-y: auto;width: 100px;">
        <div class="dade_name" v-for="(it,index) in data" @click="oens(index,it.building)">
          <i class="ivu-icon ivu-icon-ios-paper-outline" style="margin-right: 3px;margin-top: 2px;"></i>
          <div :style="index == oen ? 'color: #463aea;' : ''">{{it.building}}</div>
        </div>
      </div>
      <div style="margin-left: 130px;" v-if="dataOen">
        楼层
        <div style="width: 100px;height: 680px;overflow: auto;">
          <div v-for="it in dataOen">
            <div>{{it.BelongFloor}}</div>
          </div>
        </div>
      </div>
      <div style="margin-left: 130px;" v-if="dataOen">
        <div style="display: flex;">
          <div style="margin-top: 6px;">分摊占比</div>
          <div @click="add" style="margin-left: 20px;padding: 6px 10px 6px 10px;background-color: #66b1ff;color: #FFFFFF;border-radius: 10px;cursor: pointer;">立即保存</div>
        </div>
        <div style="height: 680px;overflow: auto;width: 680px;">
          <div v-for="(it,index) in formDynamic" :key="it.index" v-if="it.status == 1" style="margin-top: 10px;">
            <div style="display: flex;">
              <div><el-input  style="width: 150px;" v-model="formDynamic[index].start" placeholder="请输开始层数"></el-input>层
                <span style="margin-left: 10px;margin-right: 10px;">至</span>
              </div>
              <div><el-input  style="width: 150px;" v-model="formDynamic[index].end" placeholder="请输结束层数"></el-input>
                层
              </div>
              <div><el-input  style="width: 150px;margin-left: 10px;" v-model="formDynamic[index].share" placeholder="分摊占比"></el-input>
                %<el-button  @click="handleRemove(index)" type="danger" style="color: #ffffff;margin-left: 10px;">删除</el-button>
              </div>
            </div>
          </div>
          <div style="cursor: pointer;color: #ffffff;margin-top: 10px;"><el-button @click="handleAdd()" type="primary">添加</el-button></div>
        </div>
      </div>
    </div>
  </div>


</div>
</template>

<script>
import ErpProject from "../Common/erp-project";
export default {
  name: "pindexShareSetup",
  components: {
    ErpProject,
    "erp-tree": () => import('../Common/erp-tree.vue')
  },
  data () {
    return {
     loadings:true,
     search:'',
     pindex_id:'',
     region_building:'',
     building:'',
     options1: [],
     data:[],
     dataOen:'',
     oen:100000,
     name:'',
     index:0,
     formDynamic: [
       {
         start: '',
         end: '',
         share:'',
         index: 0,
         status: 1
       },
     ],
     type:'',
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted(){
    //我和我下级的项目
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
         this.options1 = backdata.data.data;
    });
  },
  methods: {
    //查询项目
    change(page){
      if(this.pindex_id == ""){
        this.$Message.error('请选择项目');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/ShareSetup/index?pindex_id='+this.pindex_id+'&region_building='+this.region_building,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.data = backdata.data.data;
          this.$Loading.finish();
          this.type = backdata.data.type;
          this.dataOen = '';
      });
    },
    //点击大楼
    oens(oen,building){
      this.building = building;
      this.oen = oen;
      let text = "&region_building="+this.region_building+'&type='+this.type;
      this.$myhttp.get('admin/ShareSetup/building?pindex_id='+this.pindex_id+"&building="+building+text,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dataOen = backdata.data.data;
          this.formDynamic = backdata.data.setup;
          this.index = backdata.data.index;
          this.$Loading.finish();
      });
    },
    //保存
    add(){
      let data = {'pindex_id':this.pindex_id,'building':this.building,'data':this.formDynamic}
      //console.log(data);
      let status = 1;
      let _this = this;
      let share = 0;
      let oen = 0;
      data.data.forEach(function(item,index){
        if(item.status == 1){
          if(item.start == "" && status != 2){
            _this.$Message.error('开始楼层不能为空');
            status = 2;
          }
          if(item.end == "" && status != 2){
            _this.$Message.error('结束楼层不能为空');
            status = 2;
          }
          if(item.share== "" && status != 2){
            _this.$Message.error('分摊比例不能为空');
            status = 2;
          }
          if(parseFloat(item.start) > parseFloat(item.end) && status != 2){
            _this.$Message.error('开始楼层不能大于结束楼层');
            status = 2;
          }
          share = parseFloat(share) + parseFloat(item.share);
        }
      });
      if(status == 2){
        return false;
      }else{
        //console.log(share);
        if(share>100){
          _this.$Message.error('分摊比例合计不能大于100的比例，合计：'+share);
          return false;
        }
        if(share<100){
          _this.$Message.error('分摊比例合计不能小于100的比例，合计：'+share);
          return false;
        }
      }

      this.$Loading.start();
      data.region_building = this.region_building;
      this.$myhttp.post('admin/ShareSetup/add',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          if(backdata.data.code==200){
             _this.$Message.success("操作成功");
          }
          this.$Loading.finish();
      });

    },

    handleAdd(){
      this.index++;
      this.formDynamic.push({
        start: '',
        end: '',
        share:'',
        index: this.index,
        status: 1
      });
    },
    handleRemove(index){
      this.formDynamic[index].status = 0;
    },

    loading(){
      this.loadings = false;
      setTimeout(() => {
          this.loadings = true;
      }, 100);
    },

    // 树组件点击触发
    nodeClick(data) {
      this.oen = 1000000;
      this.region_building = '';
      let type = true;
      data.tree.map((req,index)=>{
        //项目
        if(index == 0){
           this.pindex_id=req.id;
        }
        //分区或大楼
        if(index == 1){
          this.region_building = req.name;
        }
        if(index > 1){
          type = false;
        }
      })
      if(type){
        this.change(1)
      }else{
        this.data = [];
      }
    }

  },
  watch: {

  }
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.zhujie{
  margin-left: 14%;
  color: brown;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.dade_name{
  cursor: pointer;
  display: flex;
}
.dade_name :hover{
  color: #463aea;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/ShareSetup.vue